export const lockTypeConfig = {
  heading: "Schlösser und Zugang",
  subtitle:
    "Wie kommt der Gast in Ihre Unterkunft? Fügen Sie ein oder mehrere Schlösser hinzu (Hauseingang, Einheit…), jedes mit eigenem Namen und eigener Zugangsart.",
  loading: "Konfiguration wird geladen…",

  enable: {
    title: "Zugangscodes senden",
    sub:
      "Wenn Sie das ausschalten, senden wir dem Gast keine Zugangsschlüssel. Die Anreisehinweise werden unabhängig von dieser Einstellung weiterhin gesendet.",
  },

  scope: {
    labelRoom: "Zu konfigurierendes Zimmer",
    labelUnit: "Zu konfigurierende Einheit",
    hintRoom: "Jedes Zimmer behält seine eigene Zugangskonfiguration.",
    hintUnit: "Jede Einheit behält ihre eigene Zugangskonfiguration.",
  },

  conflict: {
    title: "Diese Bereiche nutzen diese Konfiguration nicht",
    textBefore:
      "Sie behalten ihre eigenen Schlüssel, und beim Versand gilt immer die speziellere Konfiguration.",
    textStrong: "Was Sie hier ändern, erreicht sie nicht",
    textAfter: "solange sie so eingestellt bleiben:",
    lockCount: "Schloss | Schlösser",
    applying: "Wird angewendet…",
    applyAll: "Diese Konfiguration für alle übernehmen",
  },

  lockBadge: "Schloss {n}",
  removeLock: "Schloss entfernen",
  nameLabel: "Name des Eingangs",
  namePlaceholder: "Oder einen Namen eingeben…",
  typeLabel: "Zugangsart",
  codePlaceholderBox: "Code des Schlüsseltresors · z. B. 5817",
  codePlaceholderLock: "Code des Schlosses · z. B. 5817",
  lockFallback: "Schloss",
  connectedSuffix: "verbunden",
  editConfig: "Konfiguration bearbeiten",
  configure: "Einrichten…",
  addLock: "Weiteres Schloss hinzufügen",
  roomsHint:
    "Jedes physische Zimmer hat sein eigenes Schloss und seinen eigenen Code. Richten Sie sie hier nacheinander ein.",

  wa: {
    online: "online",
    today: "Heute",
    captionOverriding: "So erhält es {source} · nicht die oben genannten Bereiche",
    captionPreview: "Vorschau · so erhält es der Gast von {source}",
  },

  modal: {
    title: "Richten Sie Ihr smartes Schloss ein",
    sub: "Wählen Sie Ihre Marke und verbinden Sie sie, um automatisch Schlüssel pro Buchung zu erzeugen.",
    close: "Schließen",
    note: "Fügen Sie dem Inserat zuerst eine Einheit hinzu, um das smarte Schloss einzurichten.",
  },

  providerOther: "Andere Marke",

  presets: {
    main: "Haupteingang",
    property: "Eingang der Unterkunft",
    unit: "Eingang der Einheit",
  },

  entryFallback: "Eingang",
  roomFallback: "Zimmer",
  yourProperty: "Ihrer Unterkunft",

  types: {
    none: {
      title: "Schlüsseltresor",
      desc: "Ein Sicherheitskasten mit den Schlüsseln der Unterkunft.",
    },
    dynamic: {
      title: "Smartes Schloss",
      desc: "Ein neuer automatischer Schlüssel für jede Buchung.",
    },
    static: {
      title: "Schloss mit festem Code",
      desc: "Ein Code, den Sie von Zeit zu Zeit manuell ändern.",
    },
  },

  source: {
    room: "dieses Zimmer",
    unit: "diese Unterkunft",
    property: "das Inserat",
  },

  preview: {
    boxText:
      "🔑 *{label} · {name}*\n\nDer Schlüsseltresor öffnet sich mit dem Code: *{code}*\n\nDarin finden Sie die Schlüssel der Unterkunft. Bitte legen Sie sie bei der Abreise wieder hinein.",
    dynamicText:
      "🔒🔑 *{label} · {name}*\n\nIhr Zugangscode lautet: *58117*\n\nEr gilt während Ihres gesamten Aufenthalts.",
    staticText:
      "🔒🔑 *{label} · {name}*\n\nDer Code des Schlosses lautet: *{code}*\n\nDamit öffnen Sie die Tür der Unterkunft.",
  },

  summary: {
    dynamic: "Smartes Schloss",
    codePrefix: "Code {code}",
    staticCode: "Fester Code",
    boxPrefix: "Schlüsseltresor {code}",
    empty: "Nicht eingerichtet",
  },

  toast: {
    saved: "Zugang gespeichert",
    saveError: "Die Zugangsart konnte nicht gespeichert werden.",
    unified: "Konfiguration vereinheitlicht",
    unifyError: "Die Konfiguration konnte nicht vereinheitlicht werden.",
    savedRoom: "Zugang gespeichert · {room}",
    saveErrorRoom: "Der Zugang für {room} konnte nicht gespeichert werden.",
    theRoom: "das Zimmer",
  },
};
